define('models/ecard/ecard_status',[ "backbone" ], function (Backbone) {

    var EcardStatus = Backbone.Model.extend({
        url: function () {
            return pf.consumerURL + "/ecards/status/"+this.REFNO;
        },
        initialize: function (options) {
            options || (options = {});

            this.REFNO = options.REFNO;

            // this.UGUID = options.UGUID;
            // this.PCGUID = options.PCGUID;
            // this.MGUID = options.MGUID;
            // this.AMT = options.AMT;
            // this.PM = options.PM;
            // this.CID = options.CID;
            // this.AGID = options.AGID;
        },
        parse: function (data) {
            var response = {};
            
            // response.UGUID = data.UGUID;
            // response.PCGUID = data.PCGUID;
            // response.MGUID = data.MGUID;
            // response.AMT = data.AMT;
            // response.PM = data.PM;
            // response.CID = data.CID;
            // response.AGID = data.AGID;
            // response.gcguid = data.gcguid;

            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};

            // data.UGUID = this.UGUID; // User GUID
            // data.PM = this.PM; // Payment Method
            // data.PCGUID = this.PCGUID; // Payment Card GUID
            // data.CID = this.CID; // Client ID
            // data.MGUID = this.MGUID; // Merchant GUID
            // data.AMT = this.AMT; // Payment Amount
            // data.AGID = this.AGID; // Aggregate ID

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return EcardStatus;
});
